export default "__VITE_ASSET__B3p1MnCn__"